import API_BASE_URL from "../../../../../../../Constants";

export const fetchDirectors = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/dobconnectdirectors/all`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    console.error("Error fetching directors:", err);
  }
};

export const fetchEmailProfiles = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/dob-profiles/emailprofiles`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    console.error("Error fetching email profiles:", err);
  }
};

/**
 * Finds an owner profile by email address using case-insensitive matching.
 * Used to match director emails with owner profiles for ELV3 submissions.
 * 
 * @param {string} email - The email address to search for
 * @returns {Promise<Object>} The matching owner profile or null if not found
 */
export const findOwnerProfileByEmail = async (email) => {
  try {
    if (!email) {
      console.error("Email parameter is required");
      return null;
    }
    
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/dob-profiles/by-email?email=${encodeURIComponent(email)}`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (response.status === 404) {
      console.log(`No owner profile found for email: ${email}`);
      return null;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  } catch (err) {
    console.error(`Error finding owner profile by email (${email}):`, err);
    return null;
  }
};
